/**
 * Stepper único da jornada branded (Aspaec/Remederi/Vikura), presente desde a
 * primeira tela — substitui o stepper interno do CheckoutStep (que só existia
 * a partir da revisão e com rótulos que não batiam com a jornada da marca).
 * Mesmo visual do StepIndicator do Consulta na Hora; as classes primary-* são
 * recoloridas pelo tema da marca.
 */
type BrandedStepperProps = {
  steps: string[]
  activeIndex: number
}

export default function BrandedStepper({ steps, activeIndex }: BrandedStepperProps) {
  return (
    <div className="mb-6">
      <div className="flex items-center justify-center">
        {steps.map((label, idx) => {
          let circleClass = 'border-2 border-solid border-gray-200 bg-white text-gray-300'
          if (idx < activeIndex) circleClass = 'border-none bg-primary-700 text-white'
          else if (idx === activeIndex)
            circleClass = 'border-2 border-solid border-primary-700 bg-white text-primary-700'

          return (
            <div key={label} className="flex items-center">
              <div
                className={`flex h-7 w-7 items-center justify-center rounded-full text-xs font-semibold transition-colors ${circleClass}`}>
                {idx < activeIndex ? '✓' : idx + 1}
              </div>
              {idx < steps.length - 1 && (
                <div
                  className={`h-0.5 w-4 transition-colors md:w-10 ${idx < activeIndex ? 'bg-primary-700' : 'bg-gray-300'}`}
                />
              )}
            </div>
          )
        })}
      </div>
      <p className="mt-2 text-center text-xs font-semibold text-gray-600">{steps[activeIndex]}</p>
    </div>
  )
}
